<div class="bg-primary"
    *ngIf="(isLoggedIn$ | async) && sharedPushNotificationService.isNotificationAvaiable && sharedPushNotificationService.isBrowserPermissionDefault">
    <div class="d-flex flex-md-row flex-column justify-content-center p-2 align-items-md-center gap-2">
        <p class="text-light h8 text-semi-bold ">{{'settings.pushNotifications.deviceDefaultInfo' | transloco}}</p>
        <div>
            <button class="btn btn-sm btn-default m-0 w-100" (click)="enablePushNotification()">
                {{'settings.pushNotifications.activate' | transloco}}
            </button>
        </div>
    </div>
</div>